import { SafePlugin } from '@atlaskit/editor-common/safe-plugin';
import { PluginKey } from '@atlaskit/editor-prosemirror/state';
var key = new PluginKey('editorStateNotificationPlugin');
export var createEditorStateNotificationPlugin = function createEditorStateNotificationPlugin(onEditorStateUpdated, onEditorViewStateUpdatedCallbacks) {
  var transactions = [];
  return new SafePlugin({
    key: key,
    state: {
      // @ts-ignore - Workaround for help-center local consumption
      init: function init() {
        return {
          latestTransaction: undefined
        };
      },
      // @ts-ignore - Workaround for help-center local consumption
      apply: function apply(tr) {
        transactions.push(tr);
        return {
          latestTransaction: tr
        };
      }
    },
    view: function view() {
      return {
        // @ts-ignore - Workaround for help-center local consumption

        update: function update(view, oldEditorState) {
          onEditorStateUpdated({
            oldEditorState: oldEditorState,
            newEditorState: view.state
          });
        }
      };
    }
  });
};